import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';

const getTreatmentsSchemas = () => {
  return PortalIdParser.get() ? {
    'acad-025': {
      identifier: PortalIdParser.get(),
      parameters: {
        group: ['control', 'variation']
      }
    }
  } : {};
};

export const TreatmentsClient = {
  client: null,

  get() {
    if (!this.client) {
      this.client = createClient({
        ceid: PortalIdParser.get(),
        treatments: getTreatmentsSchemas()
      });
    }

    return this.client;
  }

};